const chat = {
    aggregation: {
      indexedCount: '索引内の確認済み件数: {{count}}（{{grain}}）。',
      physicalRows: '物理行数',
      literalValues: 'literal 値の種類数',
      unknownTotal: '総数未確定。',
      sourceUnknown: '原典全体の取込完了は未確認です。',
      partialEvidence: '根拠は一部です。対象を絞って再検索してください。',
    },
    combinedSummary: {
      heading: '全体的な概要',
      intro: '選択されたファイル（{{count}}件）の内容を統合したサマリーです。',
      fileHeading: 'ファイル {{index}}',
      insightsHeading: '技術的知見とポイント',
    },
    fileInsights: {
      failure: {
        heading: '🔍 故障分析の重要性',
        bullet1: '根本原因の特定と対策の体系化が必要',
        bullet2: '同様の不具合の横展開防止策を検討',
      },
      environment: {
        heading: '🌡️ 環境要因への対応',
        bullet1: '使用環境条件の十分な検討と設計への反映',
        bullet2: 'グローバル市場の多様な環境条件を考慮した設計基準の見直し',
      },
      design: {
        heading: '📐 設計・開発プロセスの改善',
        bullet1: '設計基準の見直しと実使用条件との整合性確保',
        bullet2: '設計検証プロセスの強化と評価項目の追加',
      },
      testing: {
        heading: '🧪 試験・評価体制の強化',
        bullet1: '実使用条件を模擬した試験方法の確立',
        bullet2: '試験設備の導入と評価体制の整備',
      },
      materials: {
        heading: '🔬 材料・部品選定の最適化',
        bullet1: '使用環境に適した材料特性の評価と選定',
        bullet2: '材料の長期信頼性と耐久性の検証',
      },
      general: {
        heading: '📋 一般的な技術的考慮事項',
        bullet1: '文書化された知見の体系的な整理と共有',
        bullet2: '類似事例との比較分析による知見の拡充',
      },
      common: {
        heading: '💡 推奨アクション',
        bullet1: '関連技術者・部門との情報共有と議論',
        bullet2: '類似製品・プロジェクトへの横展開の検討',
        bullet3: '継続的な改善活動への組み込み',
      },
    },
    sourceLabels: {
      webSource: 'Web検索結果',
      untitledDocument: 'タイトルなしのドキュメント',
    },
    placeholder: '質問、検索、何でもお気軽に…',
    closePanel: 'パネルを閉じる',
    jumpToLatest: '最新へ移動',
    stop: '停止',
    send: '送信',
    emptyHeadline: '何でも聞いてください',
    emptyTagline: '社内ドキュメントを根拠に、REVYが回答します。',
    addContext: 'コンテキスト追加',
    attachFile: 'ファイル添付',
    attachDocument: 'ドキュメントを添付',
    allSources: 'REVY DB',
    allSourcesTooltip: '社内技術文書のみを検索',
    assistant: 'アシスタント',
    basedOn: '根拠:',
    chatTab: 'チャット',
    commands: 'コマンド',
    emptyTitle: '下の入力欄にメッセージを入力して会話を始めましょう',
    emptyDescription: 'ドキュメントの検索、要約の作成、質問への回答をお手伝いします',
    enterKey: '確定',
    file: 'ファイル',
    files: 'ファイル',
    fileMentionHint: 'ファイルを検索するか @ でメンションできます',
    fileSearchPlaceholder: 'ファイルを検索...',
    filesCount: '{{count}}件のファイル',
    filesSelected: '{{count}}件選択中',
    generateSummary: '要約を生成',
    inContext: 'コンテキスト内',
    webOnly: 'Web検索（準備中）',
    webOnlyTooltip: '現在はWeb検索を実行せず、社内技術文書のみで回答します',
    internalOnly: '社内文書のみ',
    internalOnlyTooltip: '社内技術文書のみを検索',
    messagePlaceholder: 'メッセージを入力...',
    modeSelectorTitle: 'モードを選択',
    modeSelectorHint: '/help, /ask, /plan, /drbfm でも切り替え可能',
    newConversation: '新しい会話',
    noFiles: 'ファイルがありません',
    noFilesFound: 'ファイルが見つかりません',
    openDocument: 'ドキュメントを開く',
    quickActions: 'クイックアクション',
    referenceDocuments: '参照ドキュメント',
    relevance: '関連度',
    relevanceHigh: '高',
    relevanceMedium: '中',
    relevanceLow: '低',
    relatedPassage: '関連箇所',
    relatedPassages: '{{count}}件の関連箇所',
    relatedPassagesUnit: '関連箇所',
    noPreview: 'プレビューなし',
    passageOnPage: 'ページ{{page}}の該当箇所',
    showRelatedPassages: '同じファイルの他の{{unit}} {{count}} 件を表示',
    hideRelatedPassages: '同じファイルの他の関連箇所を隠す',
    searchDocuments: 'ドキュメントを検索',
    searchResultsCount: '{{count}}件の結果',
    searchedFor: '検索キーワード',
    settings: 'チャット設定',
    sourceLabel: 'ソース: {{type}}',
    sourceLabelInternal: 'REVY DB',
    sourceLabelMixed: 'REVY DB + Web',
    sourceLabelWeb: 'Web',
    sourceListTitle: '{{title}} ({{count}}件)',
    sources: '参照元',
    sourcesTab: 'ソース',
    systemMessage: 'システムメッセージ',
    thinking: '考え中...',
    stillThinking: 'まだ考え中...',
    almostThere: 'もう少し...',
    sendMessage: 'メッセージを送信',
    inputPlaceholder: '質問、検索、何でもお気軽に...',
    notionEmptyDescription: 'ドキュメントについてREVYに質問したり、文章作成や分析などのサポートを受けることができます。',
    newChat: '新しいチャット',
    newChatConfirm: {
      title: '新しいチャットを開始',
      attachments: '添付中のファイルは引き継がれません。新しいチャットを開始してもよろしいですか？',
      streaming: '生成中の回答は中断されます。新しいチャットを開始してもよろしいですか？',
      confirm: '開始する',
    },
    switchThreadConfirm: {
      title: 'チャットを切り替える',
      attachments: '添付中のファイルは引き継がれません。切り替えてもよろしいですか？',
      streaming: '生成中の回答は中断されます。切り替えてもよろしいですか？',
      confirm: '切り替える',
    },
    retryWithModeConfirm: {
      title: '入力内容を置き換える',
      description: '入力中のテキストが選択したメッセージで置き換えられます。置き換えてもよろしいですか？',
      confirm: '置き換える',
    },
    copyMessage: 'メッセージをコピー',
    copied: 'コピーしました',
    toSend: 'で送信',
    webSearchDisabledNotice: 'Web検索は現在未対応または無効のため実行されていません。社内文書のみで回答しています。',
    newThread: '新しいスレッド',
    chatFallback: 'チャット',
    modeSwitched: 'モードを「{{mode}}」に切り替えました。{{description}}',
    noFilesSelectedForSummary: 'ファイルが選択されていません。ファイルを選択してから再度お試しください。',
    deepAnalysisInProgress: '詳細な技術分析を実行中です...',
    fileAnalysisInProgress: 'ファイルを分析中です...',
    summaryUnavailable: 'サマリーを取得できませんでした。',
    summary: '要約',
    deepTechnicalAnalysis: '詳細技術分析',
    singleFileSummaryHeading: '## {{title}} の{{type}}',
    multiFileSummaryHeading: '## 選択されたファイル（{{count}}件）の{{type}}',
    individualFileSummariesHeading: '### 個別ファイルの要約',
    individualFileAnalysesHeading: '### 個別ファイルの技術分析',
    combinedTechnicalAnalysisHeading: '### 統合技術分析',
    combinedTechnicalInsightsHeading: '### 統合技術的知見',
    summaryError: 'ファイルの要約中にエラーが発生しました。もう一度お試しください。',
    streamError: '回答の生成に失敗しました。もう一度お試しください。',
    storageUnavailable: 'チャットの保存先に接続できないため、メッセージを保存できませんでした。'
      + 'しばらくしてからもう一度お試しください。',
    askingAboutFiles: '📎 {{count}}件のファイルに対して質問中: {{fileNames}}',
    fileAddedToContext: '✅ ファイルをコンテキストに追加しました: {{name}}',
    history: 'チャット履歴',
    noHistory: 'チャット履歴がありません',
    pinned: 'ピン留め',
    recentChats: '最近のチャット',
    pinThread: 'ピン留めする',
    unpinThread: 'ピン留めを解除',
    pinThreadAria: '{{title}}をピン留め',
    unpinThreadAria: '{{title}}のピン留めを解除',
    verificationBasedOnDocuments: '文書に基づく回答',
    verificationPartlyUnsupported: '一部裏付けなし',
    verificationNeedsReviewLabel: '要確認箇所あり',
    verificationDetailsTitle: '回答の根拠チェック',
    verificationDetailsDescription: '回答文中の色付き部分が検証結果です。緑は文書に裏付けのある記述、オレンジは裏付けが確認できない記述を示します。',
    verificationSupportedClaims: '文書で裏付けあり（緑）: {{count}}文',
    verificationUnsupportedClaims: '裏付けなし（オレンジ）: {{count}}文',
    verificationWeakCitations: '関連性の低い参照: {{count}}件',
    verificationSupportedTitle: '文書で裏付けあり',
    verificationUnsupportedTitle: '裏付けなし',
    generalFallbackWarning: 'この回答はナレッジベースの文書に基づいていません。一般知識による回答のため、正確性をご確認ください。',
    completenessMissingNotice: '完備性チェック: 回答項目へ対応付けられなかった分類値（原表記）:',
    completenessNotEvaluatedNotice: '完備性チェック対象外: 対応形式の範囲外のため評価していない分類値（表示用ラベル。長い値や印字不能文字は省略・置換）:',
    verificationNeedsReview: '回答の根拠に確認が必要な箇所があります。上の「回答の根拠チェック」を開いて詳細をご確認ください。',
    retryWithMode: '別モードで再質問 →',
    deleteConfirm: 'このドキュメントを削除しますか？この操作は元に戻せません。',
    editTags: 'タグ編集',
    tagInputPlaceholder: 'タグを入力してEnter',
    viewSource: 'ソースを表示',
    modes: {
      help: {
        name: 'ヘルプ',
        description: 'システムの使い方とコマンド一覧',
      },
      settings: {
        name: '設定',
        description: 'データソース状態・利用統計',
      },
      ask: {
        name: 'Q&A',
        description: '質問応答モード（デフォルト）',
      },
      plan: {
        name: '設計深掘り',
        description: '設計に関する深い議論',
      },
      drbfm: {
        name: 'DRBFM分析',
        description: 'DRBFM分析サポート',
      },
      verification: {
        name: '設計検証',
        description: '設計検証項目の分析・改善支援',
      },
      cad: {
        name: 'CAD分析',
        description: 'CADデータの構造・設計レビュー',
      },
    },
  };

export default chat;
